import { render, staticRenderFns } from "./CopyStakeAutoclickerGameDialog.vue?vue&type=template&id=073ce3d2&scoped=true&lang=pug"
import script from "./CopyStakeAutoclickerGameDialog.vue?vue&type=script&lang=ts"
export * from "./CopyStakeAutoclickerGameDialog.vue?vue&type=script&lang=ts"
import style0 from "./CopyStakeAutoclickerGameDialog.vue?vue&type=style&index=0&id=073ce3d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "073ce3d2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VForm } from 'vuetify/lib/components/VForm';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAutocomplete,VBtn,VCardActions,VDivider,VForm,VTextField})
